import { Node, NodeConfig } from '@tiptap/core';
import { ReactNodeViewRenderer } from '@tiptap/react';
import _ from 'lodash';
import { ReportAConcernBlockNodeView } from './ReportAConcernBlockNodeView';

export const REPORT_A_CONCERN_BLOCK_NAME = 'reportAConcernBlock';

declare module '@tiptap/core' {
  interface Commands<ReturnType> {
    [REPORT_A_CONCERN_BLOCK_NAME]: {
      /**
       * Toggle a report a concern block
       */
      toggleReportAConcernBlock: () => ReturnType;
    };
  }
}

interface IReportAConcernBlockOptions {
  isSelectable: boolean;
}

export const ReportAConcernBlock = (
  config: Partial<NodeConfig<IReportAConcernBlockOptions>> = {}
) =>
  Node.create<IReportAConcernBlockOptions>(
    _.extend(
      {
        /** The name of the block. This is used to represent the block in the editor's JSON output.
         * Changing this will break old content!
         * See: https://tiptap.dev/guide/custom-extensions#name
         */
        name: REPORT_A_CONCERN_BLOCK_NAME,

        /** The content group this node belongs to.
         * See: https://prosemirror.net/docs/ref/#model.NodeSpec.group
         */
        group: 'block',

        /** Make the block draggable within the editor.
         * See: https://prosemirror.net/docs/ref/#model.NodeSpec.draggable
         */
        draggable: true,

        /** The element will be preserved when copy/pasting content.
         * See: https://prosemirror.net/docs/ref/#model.NodeSpec.defining
         */
        defining: true,

        addCommands() {
          return {
            toggleReportAConcernBlock: () => {
              if (this.editor.isActive(this.name)) {
                return ({ commands }) => {
                  return commands.deleteSelection();
                };
              } else {
                return ({ commands }) => {
                  return commands.insertContent([
                    { type: this.name },
                    { type: 'paragraph' },
                  ]);
                };
              }
            },
          };
        },

        // Needed for copy / paste
        parseHTML() {
          return [
            {
              tag: REPORT_A_CONCERN_BLOCK_NAME,
            },
          ];
        },

        // Needed for copy / paste
        renderHTML() {
          return [REPORT_A_CONCERN_BLOCK_NAME];
        },

        addNodeView() {
          return ReactNodeViewRenderer(ReportAConcernBlockNodeView);
        },
      },
      config
    )
  );
